import { CfHorizontalCarouselProps } from "./schema";
import HorizontalCarousel, { HorizontalCarouselProps } from "..";
import React from "react";

export const convertCfHorizontalCarouselProps = ({
  reverse,
  speed,
  children,
}: CfHorizontalCarouselProps) => {
  const items = React.Children.toArray(children).length;
  let duration = items * 4;

  if (speed === "fast") duration = items * 3;
  if (speed === "medium") duration = items * 4;
  if (speed === "slow") duration = items * 5;

  const props: HorizontalCarouselProps = {
    reverse,
    duration,
    children,
  };
  return props;
};

const CfHorizontalCarousel = (props: CfHorizontalCarouselProps) => {
  return (
    <div style={{ paddingBottom: "var(--space-32)" }}>
      <HorizontalCarousel {...convertCfHorizontalCarouselProps(props)} />
    </div>
  );
};

export default CfHorizontalCarousel;
